"use client";

import { useMonthlyUsageStats } from "@/hooks/use-monthly-usage-stats";
import { calculateUsageChange } from "@/lib/usage-comparison";
import { UsageStatCard } from "@/components/usage-stat-card";
import { UsageUnavailable } from "@/components/usage-unavailable";

const features = [
  { key: "merchantApi", title: "Merchant API", description: "Successful calls" },
  { key: "youzuLens", title: "Youzu Lens", description: "Visual Searches" },
  { key: "roomVisualizer", title: "Room Visualizer", description: "Room Designs" },
  { key: "magicBackground", title: "Magic Background", description: "Images Processed" },
  { key: "twoDTo3D", title: "2D to 3D", description: "Models Created" },
] as const;

export function AnalyticsOverview() {
  const { currentStats: current, previousStats: previous, error, previousError, isLoading, previousLoading } = useMonthlyUsageStats();

  if (error) {
    // A failed refresh leaves cached counts stale; do not present them as current usage.
    return <UsageUnavailable />;
  }
  const hasCurrent = current !== null && current !== undefined;

  return (
    <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5">
      {features.map(({ key, title, description }) => {
        const value = current?.[key] ?? 0;
        const previousValue = previous === undefined || previousError ? undefined : previous?.[key] ?? 0;
        const comparison = hasCurrent
          ? calculateUsageChange(value, previousValue)
          : calculateUsageChange(0, 0);
        return (
          <UsageStatCard key={key} title={title} value={value.toLocaleString()}
            description={`${description} · This month (UTC)`} comparison={comparison}
            period="previous month" valueLoading={isLoading} comparisonLoading={previousLoading} />
        );
      })}
    </div>
  );
}
